/**
 * Avatars without a photo (the Wersel style guide): a colour from a hash of the name, so each person or
 * business keeps the same one everywhere, and white initials on it.
 */
export function nameColour(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 6) - hash);
  return `hsl(${Math.abs(hash % 360)}, 50%, 45%)`;
}

export const initialsOf = (s: string) =>
  s
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]!.toUpperCase())
    .join('') || '?';
